import config from 'js/app/config';
import path from 'js/lib/path';

import type { BreadcrumbListItem } from 'bundles/seo/utils/schemaMarkupUtils';

export type BreadcrumbSegment = {
  name: string;
  href?: string;
  hidden?: boolean;
};

export type BreadcrumbLinkInput = {
  label: string;
  href: string;
};

const toAbsoluteUrl = (href: string, origin: string) => {
  return href.startsWith('http') ? href : path.join(origin, href);
};

export const linksToBreadcrumbSegments = (
  links: BreadcrumbLinkInput[],
  currentPageTitle?: string
): BreadcrumbSegment[] => {
  return [
    ...links.map(({ label, href }) => ({ name: label, href })),
    ...(currentPageTitle ? [{ name: currentPageTitle }] : []),
  ];
};

export const resolveBreadcrumbTrail = (
  segments: BreadcrumbSegment[],
  origin: string = config.url.domain,
  currentPageAbsoluteUrl?: string
): BreadcrumbListItem[] => {
  const visibleSegments = segments.filter(({ hidden }) => !hidden);

  const segmentsForResolution = (() => {
    if (!currentPageAbsoluteUrl || visibleSegments.length === 0) {
      return visibleSegments;
    }

    const lastSegment = visibleSegments[visibleSegments.length - 1];

    if (lastSegment && !lastSegment.href) {
      return [
        ...visibleSegments.slice(0, -1),
        { name: lastSegment.name, href: currentPageAbsoluteUrl, hidden: lastSegment.hidden },
      ];
    }

    return visibleSegments;
  })();

  return segmentsForResolution.map(({ name, href }) => ({
    name,
    ...(href ? { absoluteUrl: toAbsoluteUrl(href, origin) } : {}),
  }));
};
